import { render, staticRenderFns } from "./ShareDevice.vue?vue&type=template&id=b19638a6&scoped=true&"
import script from "./ShareDevice.vue?vue&type=script&lang=js&"
export * from "./ShareDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19638a6",
  null
  
)

export default component.exports